export default __webpack_public_path__ + "static/media/gil-wireframe.ee982c58.png";